import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class DPTransactionReportUseCase extends BaseUseCase {
    constructor(dpTransactionRepo) {
        super();
        this.dpTransactionRepo = dpTransactionRepo;
    }
    async fetchResult(requestData) {
        return await this.dpTransactionRepo.getDPTransactionHistory(requestData);
    }
}
export default DPTransactionReportUseCase;
